import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { AppModule } from "@app/app.module";

(function (){
    const bootstrapApp = () => {
        platformBrowserDynamic()
            .bootstrapModule(AppModule)
            .catch(err => console.error('Error bootstrapping application:', err));
    };

    // Checks DOM state before bootstrapping the Angular app
    if (document.readyState === 'interactive' || document.readyState === 'complete') {
        bootstrapApp();
    } else {
        document.addEventListener('DOMContentLoaded', bootstrapApp);
    }
})();

